<template>
  <div class="has-bg-white is-padding-bottom-xsmall vadProgramMapVue">
    <div class="is-padding-top-xsmall is-padding-right-small is-padding-bottom-small is-padding-left-small">

      <div class="columns is-vcentered is-gapless is-margin-top-xxsmall">
      <!-- <div class="columns is-vcentered is-gapless is-margin-top-xxsmall has-bg-grey3"> -->
        <div class="column is-12 is-12-fullhd tabs is-fullwidth is-separatedUnderlined is-marginless-bottom has-bg-white">
       <!--  <div class="column is-narrow is-9-widescreen is-8-fullhd tabs is-fullwidth is-separatedUnderlined is-marginless-bottom has-bg-white"> -->
          <ul class="is-uppercase">
            <li
              v-for="category in layersPin" 
              :key="category.id"
              :class="acClass(category.id)"
              @click="toggleCategory(category.id)"
              class="category-button-hover"
              ><a :class="activeClosestPinsCategoryClassName(category.id)"><span class="icon"><i :class="category.iconClass"></i></span>{{category.id}}</a>
            </li>
          </ul>
        </div>
<!--         <a class="column has-text-grey has-text-centered" @click="toggleDataPanel()">
          <span class="icon is-medium is-margin-right-xxsmall"><i class="fal fa-analytics"></i></span><span class="is-uppercase">Statistiques</span>
        </a> -->
      </div>

      <control-h-scroll :reloadControls="hasData" :pas="500" v-show="hasData">
        <div class="is-flexLine is-flexLine--fullwidth is-border-left is-border-right is-border-bottom"
          style="min-width: 100%" 
        >
          <div v-for="(closestPin, index) in closestPinsCategory" :key="closestPin.name">
            <div
              class="is-flex is-padding-top is-padding-bottom is-padding-left-small is-padding-right-large"
              :class="{ 'is-border-left': index !== 0 }"
              v-if="closestPin.text"
              @click="showPlaceNearby(closestPin)"
            >
              <div class="is-margin-right-xsmall">
                <span class="icon is-large is-size-4" :class="activeClosestPinsClassName"><i class="fal fa-2x" :class="closestPin.icon"></i></span>
              </div>
              <div>
                <div><span class="is-size-4">{{closestPin.name}}</span></div>
                <div><b class="is-size-6">{{closestPin.text}}</b></div>
                <!-- <div><b class="is-size-6">{{closestPinText(closestPin.text1, closestPin.text2, closestPin.closeness, closestPin.quantity)}}</b></div> -->
              </div>
            </div>
          </div>
        </div>
      </control-h-scroll>

      <div id="program-map" class="vue-map-container is-margin-left-xsmall is-margin-right-xsmall" style="min-height: 525px;">
        
        <button id="extrusion-button" class="button" @click="toggleVisibility('3D')">
          <span class="icon"><i :class="{'fal fa-check': active3D}"></i></span><span>3D</span>
        </button>
        <button id="satellite-button-prog" class="button" @click="toggleVisibility('mapbox-satellite')">
          <span class="icon"><i :class="{'fal fa-check': activeSatellite}"></i></span><span>Satellite</span>
        </button>
        <button id="focus-button" class="button is-transform-none" @click="centerOnProgram()">
          <span>Centrer sur le programme</span>
        </button>
        <button class="button custom-fullscreen-button" :disabled="!hasData"><!--  prevent opening full screen before all close places found, otherwise the map will reload, datas reception would be delayed and close places queries would stop before getting datas -->
          <span class="icon is-small"><i class="fas fa-expand fa-lg"></i></span>
        </button>
      </div>

      <div class="columns is-vcentered is-gapless is-padding-xsmall has-bg-light">    
        <div class="column is-5-widescreen is-6-fullhd">
          <div class="field has-addons">
            <p class="control"></p>
            <div class="is-border-top is-border-bottom is-border-left is-inline-flex is-vcentered  has-bg-white is-padding-left-xsmall is-padding-right-xsmall">
              <span class="icon is-medium is-size-4"><i class="fas fa-pennant"></i></span>
            </div>
            <p></p>
            <p class="control is-expanded">
              <input
                class="input"
                v-model="destinationAddress"
                id="addressSearch"
                type="text" 
                placeholder="Adresse de destination"
                @keyup.enter="showDestinationDurations()"
              >
            </p>
            <p @click="resetItinerary" class="control">
              <a class="button is-grey is-inverted is-border is-square">
                <span class="icon is-small is-size-4"><i class="fal fa-times-circle"></i></span>
              </a>
            </p>
          </div>
        </div>
        <div class="column is-padding-left-xsmall">
          <div class="field is-grouped">
            <div 
              v-for="itineraryMode in itineraryModes"
              :key="itineraryMode.mode"
              class="control is-expanded has-badgeCustom has-badgeCustom--topright has-badgeCustom--out-quarter"
            >
              <a @click="toggleItineraryMode(itineraryMode.mode, itineraryMode.geometry)" href="#" class="button is-border has-text-grey is-fullwidth is-min-width-0 is-padding-left-small is-padding-left-small">
                <span class="icon is-small is-size-4"><i :class="itineraryMode.class"></i></span>
                <span v-if="itineraryMode.duration !== ''" class="is-size-6 is-padding-left-xxsmall is-transform-none">{{itineraryMode.duration}}</span>
              </a>
              <span v-if="itineraryMode.active" class="badgeCustom is-small is-success is-zindex-2">
                <span class="icon is-small is-size-6"><i class="far fa-xs fa-check"></i></span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="is-padding-top-small is-padding-right-small is-padding-bottom-small is-padding-left-small">
        <div class="columns is-gapless is-vcentered">
          <div class="column is-narrow columns is-vcentered">
            <span class="dot has-bg-danger"></span>
          </div>
          <div class="column is-narrow is-padding-left-xsmall is-padding-right-xsmall">
            <span class="is-size-6 has-text-grey">Programme</span>
          </div>

          <div class="column is-narrow columns is-vcentered">
            <span class="dot is-medium has-bg-danger-lighten-2"></span>
          </div>
          <div class="column is-narrow is-padding-left-xsmall is-padding-right-xsmall">
            <span class="is-size-6 has-text-grey">Périmètre de 100 mètres</span>
          </div>

          <div class="column is-narrow columns is-vcentered">
            <span class="dot is-large has-bg-danger-lighten-3 is-border is-border--danger is-border--lighten1"></span>
          </div>
          <div class="column is-narrow is-padding-left-xsmall is-padding-right-xsmall">
            <span class="is-size-6 has-text-grey">Périmètre de 500 mètres</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ControlHScroll from '../../components/utils/controlHScroll'
  import mapboxgl from 'mapbox-gl'
  import circle from '@turf/circle'
  import distance from '@turf/distance'
  import { isNil } from 'lodash'
  const turf = require('@turf/helpers')
  let places = require('places.js') // algolia

  export default {
    name: 'ProgramMap',
    components: {ControlHScroll},
    data () {
      return {
        activeMapIndex: 1,
        activeClosestPinsCategory: 'transports',
        loadingTransportPopup: false,
        activeSatellite: false,
        active3D: false,
        allPOILayers: [],
        allPinLayers: [],
        apiNavitiaHeaders: null,
        apiNavitiaToken: 'f1b67d07-5695-4b2d-9472-75f186e0cbdc',
        closePlacesReady: 1,
        closePlacesTotal: 0,
        coverage: null,
        showClosePlace: {name: null, index: -1},
        closestPinsCategories: [
          {
            category: 'transports',
            closestPinsClassName: 'has-text-acTransport',
            subCategories: [
              {
                name: 'Bus',
                features: [],
                nameForPopup: 'bus',
                icon: 'fa-bus',
                text: '',
                sourceLayer: 'transit_stop_label',
                filter: [
                  'match',
                  [
                    'get',
                    'maki'
                  ],
                  [
                    'bus'
                  ],
                  true,
                  false
                ]
              },
              {
                name: 'Accès route rapide',
                features: [],
                nameForPopup: 'voie rapide',
                icon: 'fa-road',
                text: '',
                sourceLayer: 'motorway_junction',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'class'],
                    ['motorway'],
                    true,
                    false
                  ]
                ]
              },
              {
                name: 'Parking',
                features: [],
                nameForPopup: 'parking',
                icon: 'fa-parking',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'type'],
                    ['Parking'],
                    true,
                    false
                  ]
                ],
                navitiaPoi: 'parking'
              },
              {
                name: 'Gare',
                features: [],
                nameForPopup: 'train',
                icon: 'fa-train',
                text: '',
                sourceLayer: 'transit_stop_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'maki'],
                    ['rail'],
                    true,
                    false
                  ]
                ]/* ,
                navitiaPhysicalMode: 'Train' */
              },
              {
                name: 'Aéroport',
                features: [],
                nameForPopup: 'aeroport',
                icon: 'fa-plane',
                text: '',
                closeness: '20',
                quantity: '',
                coord: '',
                sourceLayer: 'airport_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'maki'],
                    ['airport'],
                    true,
                    false
                  ]
                ]
              }
            ]
          },
          {
            category: 'écoles',
            closestPinsClassName: 'has-text-acEcole',
            subCategories: [
              {
                name: 'Crêche',
                features: [],
                nameForPopup: 'creche',
                icon: 'fa-baby',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    ['Kindergarten'],
                    true,
                    false
                  ]
                ]
              },
              {
                name: 'École',
                features: [],
                nameForPopup: 'ecoles',
                icon: 'fa-school',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    ['School'],
                    true,
                    false
                  ]
                ]
              },
              {
                name: 'Université',
                features: [],
                nameForPopup: 'universite',
                icon: 'fa-graduation-cap',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'type'],
                    ['University'],
                    true,
                    false
                  ]
                ]/* ,
                navitiaPoi: 'university' */
              }
            ]
          },
          {
            category: 'commerces',
            closestPinsClassName: 'has-text-acCommerce',
            subCategories: [
              {
                name: 'Alimentation',
                features: [],
                nameForPopup: 'alimentation',
                icon: 'fa-shopping-cart',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'class'],
                    ['food_and_drink_stores'],
                    true,
                    false
                  ]
                ]
              },
              {
                name: 'Poste',
                features: [],
                nameForPopup: 'poste',
                icon: 'fa-mail-bulk',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    ['Post Office'],
                    true,
                    false
                  ]
                ],
                navitiaPoi: 'post_office'
              },
              {
                name: 'Restaurant',
                features: [],
                nameForPopup: 'restaurant',
                icon: 'fa-utensils',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    ['Restaurant'],
                    true,
                    false
                  ]
                ]
              },
              {
                name: 'Cafe',
                features: [],
                nameForPopup: 'cafe',
                icon: 'fa-coffee',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    ['Cafe'],
                    true,
                    false
                  ]
                ]
              },
              {
                name: 'Commerce',
                features: [],
                nameForPopup: 'commerce',
                icon: 'fa-store',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    ['Shop'],
                    true,
                    false
                  ]
                ]
              }
            ]
          },
          {
            category: 'sante',
            closestPinsClassName: 'has-text-acSante',
            subCategories: [
              {
                name: 'Docteur',
                features: [],
                nameForPopup: 'docteur',
                icon: 'fa-user-md',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    ['Doctor’s Office'],
                    true,
                    false
                  ]
                ]
              },
              {
                name: 'Pharmacie',
                features: [],
                nameForPopup: 'pharmacie',
                icon: 'fa-plus',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    ['Pharmacy'],
                    true,
                    false
                  ]
                ]
              },
              {
                name: 'Hopital',
                features: [],
                nameForPopup: 'hopital',
                icon: 'fa-hospital-alt',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    ['Hospital'],
                    true,
                    false
                  ]
                ],
                navitiaPoi: 'hospital'
              }
            ]
          },
          {
            category: 'sorties',
            closestPinsClassName: 'has-text-acSortie',
            subCategories: [
              {
                name: 'Aire de jeux',
                features: [],
                nameForPopup: 'aire de jeux',
                icon: 'fa-child',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    ['Playground'],
                    true,
                    false
                  ]
                ]
              },
              {
                name: 'Bibliotheque',
                features: [],
                nameForPopup: 'bibliotheque',
                icon: 'fa-books',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    ['Library'],
                    true,
                    false
                  ]
                ]
              },
              {
                name: 'Centre Artistique',
                features: [],
                nameForPopup: 'centre artistique',
                icon: 'fa-palette',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    [
                      'Arts Center',
                      'Community Center'
                    ],
                    true,
                    false
                  ]
                ]
              },
              {
                name: 'Theatre',
                features: [],
                nameForPopup: 'theatre',
                icon: 'fa-ticket-alt',
                text: '',
                sourceLayer: 'poi_label',
                filter: [
                  'all',
                  [
                    'match',
                    ['get', 'category_en'],
                    ['Theater'],
                    true,
                    false
                  ]
                ] // ,
               // navitiaPoi: 'theatre'
              }
            ]
          }
        ],
        feature: [],
        mapboxToken: 'pk.eyJ1IjoidGltb3RoZWViYXQiLCJhIjoiY2p0OGh6eHdoMDhkNzN5bXI0cDVpMXhpbyJ9.QYQ0e-81WZO0oFsiSH6LzA',
       // mapboxToken: 'pk.eyJ1IjoiYW50b2luZW9rZ28iLCJhIjoiY2p0dTM5aWQ3MTBndzN5bW0zbzZjdGJ1NCJ9.RD6ube6dBLKHOkbvwNeB9g',
        mapboxStyle: 'mapbox://styles/timotheebat/cjye4gf013pdn1coc4ke9hm4b',
       // mapboxStyle: 'mapbox://styles/antoineokgo/cjulbo5jd0ktx1fmwqfq122wd',
        destinationAddress: '',
        destinationAddressInPopup: '',
        drawnItineraries: [],
        filter: ['get', 'lineId'], // workaround for datas not regular in navitia for fr-idf
        hasData: false,
        indexCat: 0,
        itineraryModes: [
          {mode: 'publicTransportation', active: false, class: 'fal fa-lg fa-bus', duration: '', geometry: null},
          {mode: 'driving', active: false, class: 'fal fa-lg fa-car-alt', duration: '', geometry: null},
          {mode: 'walking', active: false, class: 'fal fa-lg fa-walking', duration: '', geometry: null},
          {mode: 'cycling', active: false, class: 'fal fa-lg fa-bicycle', duration: '', geometry: null}
        ],
        labelLayerId: '',
        layersPin: [
          {
            id: 'transports',
            iconClass: 'fal fa-bus',
            colorClass: 'is-acTransport',
            closestPinsClassName: 'has-text-acTransport',
            popupTypeColor: '#48a3c9',
            active: true,
            subcategory: [
              {id: 'train'},
              {id: 'metro'},
              {id: 'bus'},
              {id: 'tramway'},
              {id: 'parking'},
              {id: 'voie rapide'},
              {id: 'aeroport'}
            ]
          },
          {
            id: 'écoles',
            iconClass: 'fal fa-backpack',
            colorClass: 'is-acEcole',
            closestPinsClassName: 'has-text-acEcole',
            popupTypeColor: '#9d8669',
            active: false,
            subcategory: [
              {id: 'creche'},
              {id: 'ecoles'},
              {id: 'universite'}
            ]
          },
          {
            id: 'commerces',
            iconClass: 'fal fa-cash-register',
            colorClass: 'is-acCommerce',
            closestPinsClassName: 'has-text-acCommerce',
            popupTypeColor: '#f3b94c',
            active: false,
            subcategory: [
              {id: 'restaurant'},
              {id: 'bar'},
              {id: 'alimentation'},
              {id: 'cafe'},
              {id: 'commerce'},
              {id: 'poste'}
            ]
          },
          {
            id: 'santé',
            iconClass: 'fal fa-stethoscope',
            colorClass: 'is-acSante',
            closestPinsClassName: 'has-text-acSante',
            popupTypeColor: '#63b074',
            active: false,
            subcategory: [
              {id: 'hopital'},
              {id: 'docteur'},
              {id: 'pharmacie'}
            ]
          },
          {
            id: 'sorties',
            iconClass: 'fal fa-store-alt',
            colorClass: 'is-acSortie',
            closestPinsClassName: 'has-text-acSortie',
            popupTypeColor: '#e185b6',
            active: false,
            subcategory: [
              {id: 'aire de jeux'},
              {id: 'bibliotheque'},
              {id: 'centre artistique'},
              {id: 'theatre'}
            ]
          }
        ],
        marker3D: null,
        markerDestination: null,
        placesAutocomplete: null,
        placeLngLat: [],
        popup: null,
       // transportLinesSourceLayer: 'fr-IDF-transportation-line-geome', // to change if layer name change in mapbox studio
        transportLinesSourceLayer: 'sw-geometries', // to change if layer name change in mapbox studio
       // transportLinesSourceLayer: 'SW-publicTransportationShapes', // to change if layer name change in mapbox studio
        walkingDistance: 'indisponible',
        fullscreen: false
      }
    },
    props: {
      source: {
        type: Object,
        required: true
      }
    },
    watch: {
      active3D (v) {
       // console.log('Watcher -> 3D :', v, this.mapbox)
        this.toggle3DIcons()
        if (v && this.mapbox) {
          this.marker3D.addTo(this.mapbox)
        } else if (this.mapbox) {
          this.marker3D.remove()
        }
      }
    },
    computed: {
      s () {
        return this.source
      },
      markerCenter () {
        return [this.source.location.longitude, this.source.location.latitude]
      },
      closestPinsCategory () {
        let index = this.layersPin.findIndex(el => { return el.id === this.activeClosestPinsCategory })
        return this.closestPinsCategories[index].subCategories
      },
      activeClosestPinsClassName () {
        let index = this.layersPin.findIndex(el => { return el.id === this.activeClosestPinsCategory })
        return this.closestPinsCategories[index].closestPinsClassName
      }
    },
    methods: {
      // Relative to Style/Template
      acClass (category) {
        let indexCategory = this.layersPin.findIndex((element) => { return element.id === category })
        if (this.layersPin[indexCategory].active) {
          return this.layersPin[indexCategory].colorClass
        } else {
          return ''
        }
      },
      closestPinText (text1, text2, closeness, quantity) {
        return quantity + text1 + closeness + text2
      },
      activeClosestPinsCategoryClassName (categoryId) {
        if (categoryId === this.activeClosestPinsCategory) {
          let index = this.layersPin.findIndex(el => {
            return el.id === categoryId
          })
          return this.layersPin[index].closestPinsClassName
        }
      },
    // Relative to Map Interaction
      getBounds (coordinates) {
       // console.log('Method -> getBounds', coordinates)
        let bounds = new mapboxgl.LngLatBounds()
        for (let coordinate of coordinates) {
         // console.log('coordinates', coordinate)
          if (coordinate) bounds.extend(new mapboxgl.LngLat(coordinate[0], coordinate[1]))
        }
       // console.log('-1- getBounds', bounds)
        return bounds
      },
      centerOnProgram () {
        if (!this.active3D) {
          this.mapbox.flyTo({center: this.markerCenter, duration: 1500, zoom: 15})
        } else {
          this.mapbox.flyTo({center: this.markerCenter, duration: 1500, zoom: 16.5, offset: [0, -40]})
        }
      },
      toggleCategory (categoryName) {
       // console.log('Method -> toggleCategory', categoryName)
        this.indexCat = this.layersPin.findIndex(element => { return element.id === categoryName })
        let category = this.layersPin[this.indexCat]
        let visibilityParameter = ''
        if (category.active) { // hide layer
          visibilityParameter = 'none'
          category.active = false
          let indexActiveCat = this.layersPin.slice().reverse().findIndex(el => { return el.active === true })
          if (indexActiveCat === -1) { // check if there is an active category to display closest pins
            this.activeClosestPinsCategory = 'transports' // if not set defaults to transports
          } else { // if other active category, set to the last one in the list
            let count = this.layersPin.length - 1
            let finalIndex = indexActiveCat >= 0 ? count - indexActiveCat : indexActiveCat
            this.activeClosestPinsCategory = this.layersPin[finalIndex].id
          }
        } else { // show layer
          visibilityParameter = 'visible'
          category.active = true
          this.activeClosestPinsCategory = categoryName
        }
        for (let subcat of category.subcategory) {
          let subcategory = subcat.id
          if (!this.active3D) subcategory = subcategory + '-iso'
          if (this.mapbox.getLayer(subcategory)) this.mapbox.setLayoutProperty(subcategory, 'visibility', visibilityParameter)
        }
        this.hasDataTicking()
      },
      toggle3DIcons () {
       // console.log('toggle3DIcons')
        for (let category of this.layersPin) {
          if (category.active === true) {
            for (let subcategory of category.subcategory) {
              let layerIso = subcategory.id + '-iso'
              if (this.active3D) {
                this.mapbox.setLayoutProperty(subcategory.id, 'visibility', 'visible')
                this.mapbox.setLayoutProperty(layerIso, 'visibility', 'none')
              } else {
                this.mapbox.setLayoutProperty(subcategory.id, 'visibility', 'none')
                this.mapbox.setLayoutProperty(layerIso, 'visibility', 'visible')
              }
            }
          }
        }
      },
      toggleVisibility (layer, transition = true) {
        if (this.mapbox && this.marker3D !== null) {
        // console.log('Method -> toggleVisibility', layer)
          let visibility = this.mapbox.getLayoutProperty(layer, 'visibility')
          if (visibility === 'visible') {
            this.mapbox.setLayoutProperty(layer, 'visibility', 'none')
            if (layer === '3D') {
              this.active3D = false
              if (transition) this.mapbox.easeTo({pitch: 0})
            } else if (layer === 'mapbox-satellite') {
              this.activeSatellite = false
            }
          } else {
            this.mapbox.setLayoutProperty(layer, 'visibility', 'visible')
            if (layer === '3D') {
              this.active3D = true
              if (transition) this.mapbox.easeTo({pitch: 60, duration: 1300})
              if (this.activeSatellite) {
                this.mapbox.setLayoutProperty('mapbox-satellite', 'visibility', 'none')
                this.activeSatellite = false
              }
            } else if (layer === 'mapbox-satellite') {
              this.activeSatellite = true
              if (this.active3D) this.toggleVisibility('3D')
            }
          }
        }
      },
    // Common to Itinerary search and Distance from poi/transportation search
      resetItinerary (easeIn = true) {
       // console.trace('Method -> resetItinerary')
        this.destinationAddress = ''
        this.placeLngLat = []
        for (let mode of this.itineraryModes) {
          mode.active = false
          mode.duration = ''
          mode.geometry = null
        }
       // this.popup.remove()
        this.markerDestination.remove()
        for (let id of this.drawnItineraries) {  // remove all previously drawn shapes
          if (this.mapbox.getLayer(id)) this.mapbox.removeLayer(id)
          if (this.mapbox.getSource(id)) this.mapbox.removeSource(id)
        }
        this.drawnItineraries = []
        if (easeIn) {
          if (this.activeSatellite) {
            this.mapbox.easeTo({center: this.markerCenter, pitch: 0, duration: 1500, zoom: 15})
          } else {
            if (!this.active3D) {
              this.mapbox.setLayoutProperty('3D', 'visibility', 'visible')
              this.active3D = true
            }
            if (easeIn) this.mapbox.easeTo({center: this.markerCenter, pitch: 60, duration: 1500, zoom: 16, offset: [0, -40]})
          }
        }
      },
      async fetchData (type, {lngLat, coverage, nameNcity, stopId, transportMode = 'driving', poiType}) {
       // console.log('fetchData',type, lngLat, coverage, nameNcity, stopId, transportMode)
        let request = ''
        if (type === 'mapboxCity') {
          request = new Request(`https://api.mapbox.com/geocoding/v5/mapbox.places/${lngLat.lng}%2C${lngLat.lat}.json?types=place&access_token=${this.mapboxToken}&geometries=geojson`)
        } else if (type === 'mapboxDirections') {
          request = new Request(`https://api.mapbox.com/directions/v5/mapbox/${transportMode}/${this.markerCenter[0]}%2C${this.markerCenter[1]}%3B${lngLat[0]}%2C${lngLat[1]}.json?access_token=${this.mapboxToken}&geometries=geojson`)
        } else if (type === 'navitiaCoverage') {
          request = new Request(`https://api.navitia.io/v1/coord/${lngLat.lng}%3B${lngLat.lat}/?`, this.apiNavitiaHeaders)
        } else if (type === 'navitiaStopArea') {
          request = new Request(`https://api.navitia.io/v1/coverage/${coverage}/places?q=${nameNcity}`, this.apiNavitiaHeaders)
        } else if (type === 'navitiaLines') {
          request = new Request(`https://api.navitia.io/v1/coverage/${coverage}/stop_areas/${stopId}/lines?`, this.apiNavitiaHeaders)
        } else if (type === 'journey') {
          request = new Request(`https://api.navitia.io/v1/coverage/${coverage}/journeys?from=${this.markerCenter[0]}%3B${this.markerCenter[1]}&to=${this.placeLngLat[0]}%3B${this.placeLngLat[1]}&`, this.apiNavitiaHeaders)
        } else if (type === 'navitiaPoi') {
          request = new Request(`https://api.navitia.io/v1/coverage/${this.coverage}/coord/${this.markerCenter[0]}%3B${this.markerCenter[1]}/poi_types/poi_type%3Aamenity%3A${poiType}/pois?distance=3000&`, this.apiNavitiaHeaders)
        }
        try {
          let response = await fetch(request)
          return response.json()
        } catch (e) {
          console.error('An error occured while calling api:', type, e)
        }
      },
      removeDuplicates (array, key) {
        let lookup = {}
        let result = []
        for (let i = 0; i < array.length; i++) {
          if (!lookup[array[i][key]]) {
            lookup[array[i][key]] = true
            result.push(array[i])
          }
        }
        return result
      },
      secToHM (seconds) {
        let hours = parseInt(seconds / 3600) // 3,600 seconds in 1 hour
        seconds = seconds % 3600 // seconds remaining after extracting hours
        let minutes = parseInt(seconds / 60) // 60 seconds in 1 minute
        if (minutes < 10 && hours > 0) minutes = '0' + minutes
        let stringDuration
        if (hours > 0) {
          stringDuration = `${hours} h ${minutes} min`
        } else if (minutes > 0) {
          stringDuration = `${minutes} min`
        } else {
          stringDuration = '1 min'
        }
        return stringDuration
      },
      formatClosestPlaces (subcategory, filteredFeatures, range) {
        if (range <= 2500 && subcategory.name !== 'Aéroport' && subcategory.name !== 'Parking' && subcategory.name !== 'Accès route rapide') {
          let duration = range * 1.2 // calculate approximate range by walking
          duration = this.secToHM(range)
          subcategory.text = `${filteredFeatures.length} à moins de ${duration} à pieds`
        } else {
          range = range * 1.5 // add a bit distance to be at least equal to distance by streets displayed in popup
          let km = Math.round(range / 1000)
          let m = (range % 1000)
          let distance = '1 m'
          if (km === 0) {
            distance = `${m} m`
          } else {
            distance = `${km} km`
          }
          subcategory.text = `${filteredFeatures.length} à moins de ${distance}`
        }
        subcategory.features = filteredFeatures
        ++this.closePlacesReady // check if all places type has datas, in order to calculate container width to initiate swipper and display close places container
        if (this.closePlacesReady === this.closePlacesTotal) this.hasData = true // used to recalculate swipper width to display appropriate arrows
      },
      filterNcompareClosest (features, subcategory) {
        let filteredFeatures = []
        features = features.map(feature => {
          let distance = this.getDistancePoint(feature.geometry.coordinates)
          return {feature, distance}
        })
        features.sort((a, b) => a.distance - b.distance) // order by closest ones first, in order to display them by closest ones at click
        let range = 100
        let limit = 1
        if (features.length >= 3) {
          limit = 3
        } else if (features.length > 1) {
          limit = features.length
        }
        while (features.length !== 0 && filteredFeatures.length < limit) {
          filteredFeatures = []
          let featuresInRange = features.filter(feature => feature.distance <= range).map(feature => feature.feature)
          filteredFeatures = [...filteredFeatures, ...featuresInRange]
          range = range + 100
        }
        if (filteredFeatures.length !== 0) this.formatClosestPlaces(subcategory, filteredFeatures, range)
      },
      async getNavitiaPlaces (subcategory) {
        let result = null
        let closePlaces = []
        let resultPromise = null
        if ('navitiaPoi' in subcategory) {
          resultPromise = this.fetchData('navitiaPoi', {poiType: subcategory.navitiaPoi, coverage: this.coverage})
        } else if ('navitiaPhysicalMode' in subcategory) {
          resultPromise = this.fetchData('navitiaStopPoints', {physicalMode: subcategory.navitiaPhysicalMode, coverage: this.coverage})
        }
        try {
          result = await resultPromise
        } catch (e) {
          console.error('An error occured while waiting for data to be fetched:', e)
        }
        if (result.pois !== undefined) {
          closePlaces = result.pois.map(el => { return {properties: {name: el.name}, geometry: {coordinates: [el.coord.lon, el.coord.lat]}} })
          if (subcategory.name === 'Parking') closePlaces = closePlaces.filter(closePlaces => closePlaces.properties.name !== 'Parking')
        }
        this.filterNcompareClosest(closePlaces, subcategory)
      },
      async getMapboxPlaces (subcategory, previousFeatures = [], index = 0) {
        // console.log('Method -> getPoiData', subcategory.name)
        if ('navitiaPoi' in subcategory || 'navitiaPhysicalMode' in subcategory) {
          this.getNavitiaPlaces(subcategory)
        } else {
          let features = this.mapbox.querySourceFeatures('composite', {
            sourceLayer: subcategory.sourceLayer,
            filter: subcategory.filter
          })
          if ((features.length > previousFeatures.length || previousFeatures.length === 0) && index < 50) {
            ++index // used to stop the recursivity if no data found
            setTimeout(() => {
              this.getMapboxPlaces(subcategory, features, index)
            }, 1000)
          } else if (!isNil(previousFeatures) && previousFeatures.length !== 0) {
            let closePlaces = this.removeDuplicates(previousFeatures, 'id')
            this.filterNcompareClosest(closePlaces, subcategory)
          }
        }
      },
      showPlaceNearby (subcategory) {
       // console.log('-1- subcategory', subcategory, subcategory.name, this.showClosePlace.name, this.showClosePlace.index)
        let zoom = 17
        if (subcategory.name === 'Aéroport') zoom = 13
        if (subcategory.name === 'Gare' || subcategory.name === 'Accès route rapide' || subcategory.name === 'Parking') zoom = 16
        if (this.popup !== null) this.popup.remove()
        if (subcategory.name !== this.showClosePlace.name) this.showClosePlace = {name: subcategory.name, index: -1} // if it's the first time to be clicked
        ++this.showClosePlace.index
        if (this.showClosePlace.index <= subcategory.features.length - 1) { // if index exists in coordinates array length, show place
          this.getPinPopupContent(subcategory.features[this.showClosePlace.index], subcategory.nameForPopup)
          this.mapbox.flyTo({center: subcategory.features[this.showClosePlace.index].geometry.coordinates, zoom: zoom})
        } else { // if all places for this type has been displayed, turn back to program
          this.centerOnProgram()
          this.showClosePlace = {name: null, index: -1}
        }
        let index = this.layersPin.findIndex(el => { return el.id === this.activeClosestPinsCategory })
        if (this.layersPin[index].active === false) this.toggleCategory(this.layersPin[index].id) // if icons not visible,show them
      },
    // Relative to Itinerary search
      getDistancePoint (destinationCoord) {
       // console.log('destinationCoord', destinationCoord)
        if (destinationCoord.length === 2) {
          let startPoint = turf.point(this.markerCenter)
          let destinationPoint = turf.point(destinationCoord)
          return distance(startPoint, destinationPoint) * 1000
        } else {
          console.error('wrong coordinates', destinationCoord)
        }
      },
      handleCursorChange () {
        if (this.popup) this.popup.remove()
        if (this.markerDestination !== null) this.markerDestination.remove()
        if (this.drawnItineraries.length > 0) { // remove all previously drawn shapes
          for (let id of this.drawnItineraries) {
            if (this.mapbox.getLayer(id)) this.mapbox.removeLayer(id)
            if (this.mapbox.getSource(id)) this.mapbox.removeSource(id)
          }
          this.drawnItineraries = []
          for (let element of this.itineraryModes) {
            element.active = false
            element.geometry = null
          }
        }
        if (this.itineraryModes[0].duration !== '') for (let el of this.itineraryModes) el.duration = ''
        if ((this.destinationAddress.length > 5 && this.getDistancePoint(this.placeLngLat) < 3000) || (this.destinationAddress.length > 12)) {
          if (this.active3D) { // if in 3D mode, toggle 2D mode
            this.mapbox.setLayoutProperty('3D', 'visibility', 'none')
            this.active3D = false
            this.mapbox.setPitch(0)
          }
          this.markerDestination = new mapboxgl.Marker()
          this.markerDestination.setLngLat(this.placeLngLat).addTo(this.mapbox)
          let bounds = this.getBounds([this.markerCenter, this.placeLngLat])
          this.mapbox.fitBounds(bounds, {
            maxZoom: 15,
            padding: 120
          })
        }
      },
      initAlgoliaPlacesApi () {
        let latLngString = `${this.source.location.latitude},${this.source.location.longitude}`
        this.placesAutocomplete = places({
          appId: this.$configs.ALGOLIA_PLACE_APP_ID,
          apiKey: this.$configs.ALGOLIA_PLACE_APP_KEY,
          container: document.getElementById('addressSearch'),
          type: 'address',
          language: 'fr',
          countries: ['FR'],
          aroundLatLng: latLngString
         // useDeviceLocation: true
        })
        this.placesAutocomplete.on('change', e => {
          this.destinationAddress = e.suggestion.value
          this.placeLngLat = [e.suggestion.latlng.lng, e.suggestion.latlng.lat]
          this.showDestinationDurations()
        })
        this.placesAutocomplete.on('cursorchanged', e => {
          this.placeLngLat = [e.suggestion.latlng.lng, e.suggestion.latlng.lat]
          this.handleCursorChange()
         // DATA // if (this.activeDataPanel) this.toggleDataPanel()
        })
        this.placesAutocomplete.on('clear', e => {
          this.destinationAddress = ''
        })
      },
      async showDestinationDurations () {
        if (this.placeLngLat.length === 2) {
          let mapboxDurations = null
          let navitiaDurations = null
          let journeyPromise = this.getDirections(this.placeLngLat, 'journey', true) // request durations between destination and program
          let bounds = this.getBounds([this.markerCenter, this.placeLngLat])
          this.mapbox.fitBounds(bounds, {
            padding: {top: 90, bottom: 60, left: 70, right: 70}
          })
          try {
            mapboxDurations = await Promise.all([
              this.getDirections(this.placeLngLat, 'driving', true),
              this.getDirections(this.placeLngLat, 'walking', true),
              this.getDirections(this.placeLngLat, 'cycling', true)
            ])
          } catch (e) {
            console.log('No results for durations:', e)
          }
          try {
            navitiaDurations = await journeyPromise
          } catch (e) {
            console.log('No results for durations:', e)
          }
          if (mapboxDurations !== null) {
            let durations = mapboxDurations
            durations.unshift(navitiaDurations)
            let index = 0
            this.itineraryModes.map(el => {
              if (el.duration !== undefined) el.duration = durations[index]
              ++index
            })
          }
        }
      },
      drawItineraryRoute (coordinates, id, color, dashArray) {
       // console.log('Method -> drawItineraryRoute', coordinates, id, color)
        this.mapbox.addLayer({
          'id': id,
          'type': 'line',
          'source': {
            'type': 'geojson',
            'data': {
              'type': 'Feature',
              'properties': {},
              'geometry': {
                'type': 'LineString',
                'coordinates': coordinates
              }
            }
          },
          'layout': {
            'line-join': 'round',
            'line-cap': 'round'
          },
          'paint': {
            'line-color': color,
            'line-width': 4,
            'line-dasharray': dashArray
          }
        }, '3D')
        this.drawnItineraries.push(id)
      },
      async toggleItineraryMode (mode, geometries) {
        let alreadySelected = false
        if (this.placeLngLat.length === 2 && geometries !== null) {
          for (let element of this.itineraryModes) {
            if (element.mode === mode) {
              if (element.active === true) { // if already active, hide routes
                element.active = false
                alreadySelected = true
                for (let id of this.drawnItineraries) {  // remove all previously drawn shapes
                  if (this.mapbox.getLayer(id)) this.mapbox.removeLayer(id)
                  if (this.mapbox.getSource(id)) this.mapbox.removeSource(id)
                  this.drawnItineraries = []
                }
              } else {
                element.active = true
              }
            } else {
              element.active = false
            }
          }
          if (!alreadySelected) {
            if (Array.isArray(geometries[0])) geometries = [{id: 'itineraryRoute', type: 'street_network', mode: mode, geojson: {coordinates: geometries}}] // check if data comes from mapbox, else is from navitia
            for (let id of this.drawnItineraries) {  // remove all previously drawn shapes
              if (this.mapbox.getLayer(id)) this.mapbox.removeLayer(id)
              if (this.mapbox.getSource(id)) this.mapbox.removeSource(id)
            }
            this.drawnItineraries = []
            for (let geometry of geometries) {
              let dashArray = [1]
              let color = '#000'
              if (geometry.type === 'street_network') {
                color = '#48a3c9'
                if (geometry.mode === 'walking') {
                  dashArray = [0.01, 1.5]
                } else if (geometry.mode === 'cycling') {
                  dashArray = [2, 1.5]
                }
              } else if (geometry.type === 'public_transport' && geometry.display_informations.color.length > 0) {
                color = '#' + geometry.display_informations.color
              }
              if (geometry.geojson !== undefined) {
                if (this.mapbox.getLayer(geometry.id)) this.mapbox.removeLayer(geometry.id)
                if (this.mapbox.getSource(geometry.id)) this.mapbox.removeSource(geometry.id)
                this.drawItineraryRoute(geometry.geojson.coordinates, geometry.id, color, dashArray)
               /*  let pointsArray = geometry.geojson.coordinates.slice(0)
                pointsArray.push(this.markerCenter, this.placeLngLat) */
              }
            }
          }
        }
      },
    // Relative to Distance from pin & public transportation infos
      async getDirections (lngLat, transportMode, itineraryMode) {
       // console.log('getDirections',lngLat, transportMode, itineraryMode)
        let result = null
        try {
          if (transportMode === 'journey') {
            let coverage = null
            try {
              coverage = await this.fetchData('navitiaCoverage', {lngLat: {lng: lngLat[0], lat: lngLat[1]}})
            } catch (e) {
              console.log('No results for directions:', e)
            }
            if (coverage.regions !== undefined) result = await this.fetchData('journey', {coverage: coverage.regions[0]})
          } else {
            result = await this.fetchData('mapboxDirections', {transportMode: transportMode, lngLat: lngLat})
          }
        } catch (e) {
          console.log('No results for directions:', e)
        }
        let stringDuration = 'indisponible'
        if (result !== undefined && result !== null) {
          if (itineraryMode) { // get itinerary shapes
            if (transportMode === 'journey' && result.journeys !== undefined) {
              this.itineraryModes[0].geometry = result.journeys[0].sections
            } else if (result.routes !== undefined && result.routes[0] !== undefined) {
              for (let el of this.itineraryModes) { if (el.mode === transportMode) el.geometry = result.routes[0].geometry.coordinates }
            }
          }
          if (transportMode === 'walking' && result.routes !== undefined) { // get itinerary distance (walking by default)
            let distance = Math.round(result.routes[0].distance)
            this.walkingDistance = `${distance} mètres`
            if (distance > 1000) {
              let km = Math.trunc(distance / 1000)
              if (distance % 1000 > 500) ++km
              this.walkingDistance = `${km} km`
            }
          }
          let duration = null
          if (transportMode === 'journey') { // get itinerary duration
            if (result.journeys !== undefined) duration = result.journeys[0].duration
          } else if (result.routes !== undefined && result.routes[0] !== undefined) {
            duration = result.routes[0].duration
          }
          if (duration !== undefined && duration !== null) stringDuration = this.secToHM(duration)
        }
        return stringDuration
      },
      displayPopup (lngLat, stringFeatures) {
       // console.log('method -> displayPopup', lngLat)
        let offset = 15
        if (this.popup !== null) { // if there is already a popup, removes it
          this.popup.remove()
          if (this.mapbox.getLayer('itineraryRoute')) { // if clicking on pin and there is an itinerary route drew, removes it
            this.resetItinerary(false)
          }
        }
        this.popup = new mapboxgl.Popup({
          className: 'program-popup',
          closeOnClick: false,
          closeButton: false,
          offset: offset,
          maxWidth: 'none'
        })
        this.popup.setLngLat(lngLat) // set popup
          .setHTML(stringFeatures)
          .addTo(this.mapbox)
        let element = document.getElementsByClassName('custom-popup-close-button')[0]
        element.addEventListener('click', () => {
          this.popup.remove()
          if (this.showClosePlace.index !== -1) {
            this.centerOnProgram()
            this.showClosePlace = {name: null, index: -1}
          }
          if (this.mapbox.getLayer('transportationLine')) {
            this.mapbox.removeLayer('transportationLine')
            this.centerOnProgram()
          }
        })
        element.addEventListener('mouseover', () => { document.body.style.cursor = 'pointer' })
        element.addEventListener('mouseleave', () => { document.body.style.cursor = '' })
      },
      async getPinPopupContent (feature, nameForPopup) {
       // console.log('methode -> getPinPopupContent', feature, nameForPopup)
        if (this.mapbox.getLayer('transportationLine')) this.mapbox.removeLayer('transportationLine')
        this.loadingTransportPopup = false
        let poiLngLat = feature.geometry.coordinates // request walking distance and durations between pin and program
        let walkingDurationPromise = this.getDirections(poiLngLat, 'walking')
        let cyclingDurationPromise = this.getDirections(poiLngLat, 'cycling')
        let drivingDurationPromise = this.getDirections(poiLngLat, 'driving')
        let type = null
        if (nameForPopup) {
          type = nameForPopup
        } else {
          type = feature.layer.id.split('-')[0]
        }
        let color = '' // get color for pin name
        for (let category of this.layersPin) {
          for (let subcategory of category.subcategory) { if (subcategory.id === type) color = category.popupTypeColor }
        }
        let htmlLinesInfo = ''
        let name = feature.properties.name
        if (name === undefined) name = 'Nom inconnu'
        let lngLat = {lng: feature.geometry.coordinates[0], lat: feature.geometry.coordinates[1]}
        let isPublicTransport = false
        let coveragePromise = null // request datas to display available public transportation lines
        let cityPromise = null
        if (type === 'bus' || type === 'tramway' || type === 'metro') { // check if transport to display lines
          isPublicTransport = true
          cityPromise = this.fetchData('mapboxCity', {lngLat: lngLat})
          coveragePromise = this.fetchData('navitiaCoverage', {lngLat: lngLat})
          let stopName = 'Arrêt '
          name = stopName + name
          if (type === 'metro') stopName = 'Station '
          type = stopName + 'de ' + type
          htmlLinesInfo = "<div class='available-lines-outer'><div class='available-lines-inner'>Recherche d'informations en cours …</div></div>"
        }
        if (type === 'ecoles') { // format pin description according to pin category
          type = name.split(' ')[0]
          if (type === 'Groupe') {
            type = 'Groupe scolaire'
          } else if (type !== 'École' && type !== 'Collège' && type !== 'Lycée') {
            type = 'Centre pédagogique'
          }
        } else if (type === 'train') {
          type = 'Gare de ' + type
        } else if (type === 'aeroport') {
          type = 'Aéroport'
        }
        type = type.charAt(0).toUpperCase() + type.slice(1)
        let durations = ['?', '?', '?']
        try {
          durations = await Promise.all([drivingDurationPromise, cyclingDurationPromise, walkingDurationPromise]) // prepare popup content
        } catch (e) {
          console.log('No results for durations:', e)
        }
        let htmlPinDescription = `<div class="custom-popup-close-button">
                                    <span class="icon is-small is-size-4"><i class="fal fa-times-circle"></i></span>
                                  </div>
                                  <div style="font-weight:bold;font-size:medium;color:${color}">${type}</div>
                                  <div class="popup-poi-name">
                                    <div>${name}&nbsp;-&nbsp;</div>
                                    <div style="white-space:nowrap">${this.walkingDistance}</div>
                                  </div>`
        let htmlDestinationDurations = `<div class="columns popup-duration" >
                                    <div style="margin-right:7px;"><span class="icon"><i class="fa fa-car"></i></span>:&nbsp; ${durations[0]}</div>
                                    <div style="margin-right:5px;"><span class="icon"><i class="fa fa-bicycle"></i></span>:&nbsp; ${durations[1]}</div>
                                    <div><span class="icon"><i class="fa fa-walking"></i></span>:&nbsp ${durations[2]}</div>
                                  </div>`
        let stringFeatures = htmlPinDescription + htmlLinesInfo + htmlDestinationDurations
        this.displayPopup(poiLngLat, stringFeatures)
        if (isPublicTransport) { // get network information if concerned
          let city = null
          try {
            city = await cityPromise // get promise result requested before
          } catch (e) {
            console.log('No results for city name:', e)
          }
          let coverage = null
          try {
            coverage = await coveragePromise
          } catch (e) {
            console.log('No results for coverage:', e)
          }
          this.loadingTransportPopup = true
          let stopId = null
          if (city !== null && coverage !== null) {
            try {
              stopId = await this.fetchData('navitiaStopArea', {nameNcity: feature.properties.name + '' + city.features[0].text, coverage: coverage.regions[0]})
            } catch (e) {
              console.log('No results for stop area:', e)
            }
          }
          let transportLines = null
          if (stopId.places !== null && coverage !== null) {
            try {
              transportLines = await this.fetchData('navitiaLines', {stopId: stopId.places[0].id, coverage: coverage.regions[0]})
            } catch (e) {
              console.log('No results for transport lines:', e)
            }
          }
          let hasLine = false
          if (transportLines !== null && transportLines.lines !== undefined) {
            transportLines = transportLines.lines
            let sampleLines = ''
            for (let line of transportLines) {
              console.log('line from navitia', line)
              let lineId = line.id.split('line:')[1]
              if (line.code !== '') {
                hasLine = true
                let style = ''
                if (line.color) {
                  style = `style="color:#${line.text_color};background:#${line.color};"`
                } else {
                  style = `style="border:solid;border-color:lightgray;border-width:thin"`
                }
                sampleLines += `<div class="transport-line" data-route="${lineId}" ${style}>${line.code}</div>`
                htmlLinesInfo = `<div class='transport-lines'><div class="columns is-multiline" style="margin-top:10px;">${sampleLines}</div></div>`
              }
            }
          }
          if (!hasLine) htmlLinesInfo = "<div class='available-lines-outer'><div class='available-lines-inner'>(Donnés de transports non disponibles)</div></div>" // handle missing informations
          stringFeatures = htmlPinDescription + htmlLinesInfo + htmlDestinationDurations // Update popup content with public transport information
          if (this.loadingTransportPopup) this.displayPopup(poiLngLat, stringFeatures) // set popup with new information if no click on another pin
          this.setClickOnTransportLines() // draw transportation line when click on icon
        }
      },
      initLineBounds (lineId) {
       // console.log('method -> initLineBounds')
        let features = this.mapbox.querySourceFeatures('composite', {
          sourceLayer: this.transportLinesSourceLayer,
          filter: [
            'all',
            [
              'match',
              this.filter,
              [lineId],
              true,
              false
            ]
          ]
        })
        if (features[0] !== undefined) {
          let bigBounds = new mapboxgl.LngLatBounds()
          for (let feature of features) {
            let littleBounds = new mapboxgl.LngLatBounds()
            if (feature.geometry.coordinates[0][0].length === 2) {
              for (let coordinatesList of feature.geometry.coordinates) {
                littleBounds.extend(this.getBounds(coordinatesList))
              }
            } else {
              littleBounds.extend(this.getBounds(feature.geometry.coordinates))
            }
            bigBounds.extend(littleBounds)
          }
          this.mapbox.fitBounds(bigBounds, { padding: 10 })
        }
      },
      drawTransportationLine (lineId) {
        // console.log('Method -> drawTransportationLine', lineId, color)
        if (this.mapbox.getLayer('transportationLine')) this.mapbox.removeLayer('transportationLine')
        this.mapbox.addLayer({
          'id': 'transportationLine',
          'type': 'line',
          'source': 'composite',
          'source-layer': this.transportLinesSourceLayer,
          'filter': [
            'all',
            [
              'match',
              this.filter,
              [lineId],
              true,
              false
            ]
          ],
          'layout': {
            'line-join': 'round',
            'line-cap': 'round'
          },
          'paint': {
            'line-color': [
              'concat',
              '#',
              ['get', 'lineColor']
            ],
            'line-width': 4
          }
        }, '3D')
      },
      hasShapes (lineId) {
        let test = this.mapbox.querySourceFeatures('composite', {
          sourceLayer: this.transportLinesSourceLayer,
          filter: [
            'all',
            [
              'match',
              this.filter,
              [lineId],
              true,
              false
            ]
          ]
        })
        if (test.length > 0) return true
        return false
      },
      setClickOnTransportLines () {
       // console.log('Method -> setClickOnTransportLines')
        let htmlElements = document.getElementsByClassName('transport-line')
        let lineId = ''
        let firstClick = true
        for (let element of htmlElements) {
          let hasShape = false
          element.addEventListener('mouseover', () => {
            lineId = element.getAttribute('data-route')
            if (this.coverage === 'fr-idf') {
              lineId = lineId.split(':') // workaround for datas not regular in navitia IDF
              lineId = 'OIF:' + lineId[1] + ':' + lineId[2]
              console.log('lineId custom', lineId)
              this.filter = ['get', 'routeId']
            }
            hasShape = this.hasShapes(lineId)
            if (hasShape) document.body.style.cursor = 'pointer'
          })
          element.addEventListener('mouseleave', () => {
            document.body.style.cursor = ''
          })
          element.addEventListener('click', (e) => {
            console.log('hasShape', hasShape, 'firstClick', firstClick)
            if (hasShape) {
              this.drawTransportationLine(lineId)
              if (firstClick) {
                firstClick = false // zoom out at first click to be able to get more result at query for init line bounds
                this.mapbox.zoomTo(13.5)
                this.mapbox.once('moveend', () => { this.initLineBounds(lineId) })
              } else {
                this.initLineBounds(lineId)
              }
            }
          })
        }
      },
    // relative to map setup
      addAnimatedImage () {
       // console.log('Method -> add animated image')
        let _this = this
        let size = 100
        let pulsingDot = {
          width: size,
          height: size,
          data: new Uint8Array(size * size * 4),
          onAdd: function () {
            let canvas = document.createElement('canvas')
            canvas.width = this.width
            canvas.height = this.height
            this.context = canvas.getContext('2d')
          },
          render: function () {
            let duration = 1500
            let t = (performance.now() % duration) / (duration * 1.5)
            let radius = size / 3 * 0.3
            let outerRadius = size / 2 * 0.7 * t + radius
            let context = this.context
            // draw circle
            context.clearRect(0, 0, this.width, this.height)
            context.beginPath()
            context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2)
            context.fillStyle = 'rgba(239, 64, 60,' + (1 - t) + ')'
            context.fill()
            // update this image's data with data from the canvas
            this.data = context.getImageData(0, 0, this.width, this.height).data
            // keep the map repainting
            _this.mapbox.triggerRepaint()
            // return `true` to let the map know that the image was updated
            return true
          }
        }
        this.mapbox.addImage('pulsing-dot', pulsingDot, { pixelRatio: 2 })
      },
      setClickOnPin () {
        for (let layer of this.allPinLayers) { // Change the cursor style as a UI indicator.
          this.mapbox.on('mousemove', layer, () => { this.mapbox.getCanvas().style.cursor = 'pointer' })
          this.mapbox.on('mouseleave', layer, () => { this.mapbox.getCanvas().style.cursor = '' })
          let layerIso = layer + '-iso'
          this.mapbox.on('mousemove', layerIso, () => { this.mapbox.getCanvas().style.cursor = 'pointer' })
          this.mapbox.on('mouseleave', layerIso, () => { this.mapbox.getCanvas().style.cursor = '' })
        }
        this.mapbox.on('click', (e) => { // Query features on click and display them in the previously created popup
          let features = this.mapbox.queryRenderedFeatures(e.point, {layers: this.allPinLayers})
          // if the point click correspond to a POI or transport layer calls the popup method
          if (features[0] !== undefined && this.allPinLayers.includes(features[0].layer.id)) this.getPinPopupContent(features[0])
        })
      },
      hasDataTicking () {
        // Rendre reactif pour relancer le calcul du scrollHorizontal
        this.hasData = false
        this.$nextTick(() => {
          this.hasData = true
        })
      },
      toggleFullscreenHelp () {
        // HB : fonction basée sur le modele des fonctions "toggleFullscreen" que l'on trouve ailleur dans l'outil. Je ne comprends pas pourquoi on repette sans cesse la fonction "toggleFullscreenHelp"
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          document.querySelector('.l-header').style.zIndex = '0'
          document.querySelector('.l-navigationmain').style.zIndex = '0'
        } else {
          document.querySelector('.l-header').style.zIndex = '36'
          document.querySelector('.l-navigationmain').style.zIndex = '37'
        }
      },
      customFullscreen () {
        // Full screen personnalisé
        let fullscreenButton = document.getElementsByClassName('custom-fullscreen-button')
        fullscreenButton[0].addEventListener('click', (e) => {
          this.$el.classList.toggle('is-fullscreen')
          this.toggleFullscreenHelp()
          this.hasDataTicking()
          setTimeout(() => {
            this.mapbox.resize()
          }, 0)
        })
      },
      set3DLayer () {
        this.mapbox.addLayer({
          'id': '3D',
          'source': 'composite',
          'source-layer': 'building',
          'filter': ['==', 'extrude', 'true'],
          'type': 'fill-extrusion',
          'minzoom': 15,
          'layout': {
            'visibility': 'none'
          },
          'paint': {
            'fill-extrusion-color': '#eeeeee',
            // use an 'interpolate' expression to add a smooth transition effect to the buildings as the user zooms in
            'fill-extrusion-height': [
              'interpolate', ['linear'], ['zoom'],
              15, 0,
              15.05, ['get', 'height']
            ],
            'fill-extrusion-base': [
              'interpolate', ['linear'], ['zoom'],
              15, 0,
              15.05, ['get', 'min_height']
            ],
            'fill-extrusion-opacity': 0.6
          }
        }, this.labelLayerId)
      },
      addMarkers () {
       // console.log('Method -> add marker')
        let center = this.markerCenter
        let circle100meters = circle(center, 0.1)
        this.mapbox.addLayer({
          'id': 'circle100meters-fill',
          'type': 'fill',
          'source': {
            'type': 'geojson',
            'data': circle100meters
          },
          'paint': {
            'fill-color': '#ef403c',
            'fill-opacity': 0.2
          }
        }, this.labelLayerId)

        let circle500meters = circle(center, 0.5)
        this.mapbox.addLayer({
          'id': 'circle500meters-outline',
          'type': 'line',
          'source': {
            'type': 'geojson',
            'data': circle500meters
          },
          'paint': {
            'line-color': '#f38787',
            'line-opacity': 0.8,
            'line-width': 2
          }
        }, this.labelLayerId)

        this.mapbox.addLayer({
          'id': 'circle500meters-fill',
          'type': 'fill',
          'source': {
            'type': 'geojson',
            'data': circle500meters
          },
          'paint': {
            'fill-color': '#f7b5b5',
            'fill-opacity': 0.3
          }
        }, this.labelLayerId)
        // add center circle after the other circle to keep it over them
        this.mapbox.addLayer({
          'id': 'programMarker',
          'type': 'symbol',
          'source': {
            'type': 'geojson',
            'data': {
              'type': 'FeatureCollection',
              'features': [{
                'type': 'Feature',
                'geometry': {
                  'type': 'Point',
                  'coordinates': center
                },
                'properties': {}
              }]
            }
          },
          layout: {
            'icon-image': 'pulsing-dot',
            'symbol-z-order': 'source',
            'icon-allow-overlap': true,
            'icon-ignore-placement': true,
            'icon-padding': 0,
            'icon-pitch-alignment': 'map'
          }
        })
      },
      setCurrentMap () {
        mapboxgl.accessToken = this.mapboxToken
        const mapConfig = {
          container: 'program-map',
          style: this.mapboxStyle,
          center: [this.markerCenter[0], this.markerCenter[1] - 0.01],
          zoom: 9,
          scrollZoom: false
        }
        if (!mapboxgl.supported()) {
          alert('Your browser does not support Mapbox GL')
        } else {
          this.mapbox = new mapboxgl.Map(mapConfig)

          const navigationControl = new mapboxgl.NavigationControl({ // setup map controls
           // showCompass: false,
            showZoom: true
          })
          this.mapbox.addControl(navigationControl, 'top-right')
          this.customFullscreen()

          this.mapbox.on('load', () => {
            let layers = this.mapbox.getStyle().layers // identify last layer of symbol or label to keep them above new layer added after,
            let index = layers.findIndex(layer => layer.type === 'symbol' && layer.layout['text-field']) // can be replaced by 'building-number-label'
            this.labelLayerId = layers[index].id // depending on layers order in the style created in mapbox studio

            this.addAnimatedImage()
            this.addMarkers()
            this.marker3D = new mapboxgl.Marker({ color: '#ef403c' })
            this.marker3D.setLngLat(this.markerCenter).addTo(this.mapbox)
            this.set3DLayer()
            this.setClickOnPin() // setup poi mousehover and action on click
            this.initAlgoliaPlacesApi() // initiate algolia places search
            this.toggleVisibility('3D', false) // switch by default to 3D
            for (let category of this.closestPinsCategories) {
              for (let subcategory of category.subCategories) { this.getMapboxPlaces(subcategory) } // get data for closest places
            }
            console.log('style', this.mapbox.getStyle())
            this.mapbox.flyTo({center: [this.markerCenter[0], this.markerCenter[1] - 0.0012], pitch: 60, duration: 5500, zoom: 15.8})
          })
        }
      }
    },
    mounted () {
     // console.log('----- Mounted -----')
      this.setCurrentMap()
    },
    async created () {
     // console.log('---created ---')
      let myHeaders = new Headers()
      myHeaders.append('Authorization', 'Basic ' + btoa(this.apiNavitiaToken))
      this.apiNavitiaHeaders = {
        method: 'GET',
        headers: myHeaders,
        mode: 'cors',
        cache: 'default'
      }
      let myHeaders2 = new Headers()
      myHeaders2.append('Origin', this.apiBondevisiteOrigin)
      this.apiBondevisiteHeaders = {
        method: 'GET',
        headers: myHeaders2,
        mode: 'cors',
        cache: 'default'
      }
      let coverage = null
      let coveragePromise = this.fetchData('navitiaCoverage', {lngLat: {lng: this.markerCenter[0], lat: this.markerCenter[1]}})
      // get length of all subcategories to check if datas for each subcategories have been queried to display closest places
      for (let category of this.closestPinsCategories) {
        this.closePlacesTotal += category.subCategories.length
      }
      // get all layers name
      for (let category of this.layersPin) {
        for (let subcategory of category.subcategory) {
          this.allPinLayers.push(subcategory.id, subcategory.id + '-iso')
        }
      }
      try {
        coverage = await coveragePromise
      } catch (e) {
        console.log('No results for coverage:', e)
      }
      this.coverage = coverage.regions[0]
    }
  }
</script>

<style lang="sass">
.vadProgramMapVue
  &.is-fullscreen
    .ap-with-places
      top: unset !important
      bottom: 100%
  .mapboxgl-popup .fa-times-circle
    color: #666
  .mapboxgl-popup .fa-times-circle:hover
    color: #202020
  .mapboxgl-ctrl:hover,
  .custom-fullscreen-button:hover
  #extrusion-button:hover,
  #satellite-button-prog:hover,
  #focus-button:hover
    background-color: #f7f7f7
  .mapboxgl-ctrl-group, .custom-fullscreen-button, #extrusion-button, #satellite-button-prog, #focus-button
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2) !important
  .custom-fullscreen-button, #extrusion-button, #satellite-button-prog, #focus-button
    position: absolute
    align-items: center
    height: 28px
    z-index: 10
    color: #4a4a4a
    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif
  #extrusion-button, #satellite-button-prog
    top: 10px
    padding-left: 10px
  #extrusion-button
    left: 10px
    min-width: 70px
  #satellite-button-prog
    left: 85px
  #focus-button
    top: 10px
    right: 50px
  .custom-fullscreen-button
    top: 110px
    right: 10px
    width: 30px
    height: 30px
    min-width: 0
    padding: 0
  .custom-popup-close-button
    display: flex
    position: absolute
    top: 6px
    right: 6px
  .mapboxgl-popup-content
    border-radius: 6px
    background: rgba(255, 255, 255, 0.9)
    padding: 8px 8px 9px
  .available-lines-outer
    display: flex
    align-content: center
    height: 50px
  .available-lines-inner
    margin-top: 10px
    height: 13px
    font-style: italic
    color: #000
  .transport-line
    min-width: 30px
    text-align: center
    height: 30px
    margin: 0px 5px 5px 0px
    font-weight: bold
    padding: 5px 4px 5px 4px
  .transport-lines
    max-width: 260px
    display: flex
    align-content: center
    min-height: 50px
  .popup-poi-name
    display: flex
    flex-wrap: wrap
    margin-right: 20px
    font-size: larger
    max-width: 220px
    width: max-content
  .popup-duration
    margin-top: 10px
    margin-right: 20px
    width: max-content
  .itinerary-info
    color: #4a4a4a
  .itinerary-address
    font-weight: bold
    font-size: larger
    color: #48a3c9
    margin-right: 20px
  .ap-input-icon, .ap-icon-clear
    display: none
  .ap-input-icon, .ap-icon-clear
    display: none
  #beta-icon
    z-index: inherit
  .mapboxgl-canvas
    z-index: -1
</style>



// WEBPACK FOOTER //
// src/components/program/ProgramMap.vue